import React from 'react';

const DIAS_SEMANA = [
  { label: 'Dom', value: 'SUNDAY' },
  { label: 'Seg', value: 'MONDAY' },
  { label: 'Ter', value: 'TUESDAY' },
  { label: 'Qua', value: 'WEDNESDAY' },
  { label: 'Qui', value: 'THURSDAY' },
  { label: 'Sex', value: 'FRIDAY' },
  { label: 'Sab', value: 'SATURDAY' },
];

export default function DiasSemanaSelector({ diasSelecionados = [], onChange }) {
  const toggleDia = (dia) => {
    if (diasSelecionados.includes(dia)) {
      onChange(diasSelecionados.filter((it) => it !== dia));
    } else {
      onChange([...diasSelecionados, dia]);
    }
  };

  return (
    <div className='dias-semana-selector d-flex flex-wrap'>
      {DIAS_SEMANA.map((it) => (
        <p
          key={it.value}
          className={
            diasSelecionados.includes(it.value)
              ? 'dot selected ml-1'
              : 'dot ml-1'
          }
          onClick={() => toggleDia(it.value)}
        >
          {it.label}
        </p>
      ))}
    </div>
  );
}
